import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

import { DealVersion } from './deal.types';
import { User } from './users.types';
import { DealComment } from './deal-comments.types';
import {
  ExportServiceOption,
  ExportableDealDetailsTabs,
  ExportableMonitorTabs,
  ExportableManagerTabs,
  ExportableBidcompTabs
} from './export-modal.types';
import { ExcelWorkSheet } from '../utils/export/excel/worksheet';

export interface DealExportViewModel extends DealVersion {
  comments?: DealComment[];
  assignedUsersData?: User[];
}

export type ExportConfig<T extends string> = {
  [key in T]?: boolean;
};

export interface ExportService {
  dialogOption$: Observable<ExportServiceOption>;
  dialogOptionName:
    | ExportableDealDetailsTabs
    | ExportableMonitorTabs
    | ExportableManagerTabs
    | ExportableBidcompTabs;
  isReady$: Observable<boolean>;
  getWorksheets$(config: ExportConfig<string>): Observable<ExcelWorkSheet[]>;
}

export interface ExportConfigProvider {
  getFilename(): Observable<string>;

  getExportServices(): ExportService[];
}

export const ConfigProviderToken = new InjectionToken<ExportConfigProvider>(
  'ConfigProvider'
);

export enum SummaryExportConfigParamName {
  analytics = 'Analytics',
  internalMetrics = 'Internal Metrics',
  secondary = 'S&P MI Eval'
}

export enum ActiveCalendarConfigParamName {
  internalMetrics = 'Internal Metrics'
}

export enum UWExportConfigParamName {
  uwAmount = 'Underwriter Amount',
  uwAllotment = 'Underwriter Amount by Allotment'
}
